import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, ButtonGroup, Modal, ModalBody} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import moment from 'moment-timezone';
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import Select from "react-select";
import TextField from "@material-ui/core/TextField";
import TicketAuditReviewLink from "utils/TicketAuditReviewLink";
import {Objects, Parts} from "../index";
import Collections from "./index";
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";
import {freshdeskTicketExport} from "utils/freshdeskTicket";
import Search from '@material-ui/icons/Search'

export default class HelpDesksUnfiltered extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Users_Help_Desk._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state = {
			...this.state,
			search: "",
			regions: [],
			users: [],
			field_engineers: null,
			showFinancial: false,
			showDate: false,
			help_desk_contacted_modal: false
		}

		try {
			if (localStorage.getItem('dateHelpdesksUnfiltered')) {
				this.state.filterDate = moment((localStorage.getItem('dateHelpdesksUnfiltered'))).format();
			} else {
				this.state.filterDate = moment(Date.now()).format();
			}

		} catch (e) {
			console.log(e, 'error')
		}
		moment.tz.setDefault("America/Phoenix");
	}

	async componentDidMount() {
		super.componentDidMount();
		await this.getHelpdesks();
	}

	getHelpdesks = async () => {
		let model = new API.BuildClass(Types.Users_Help_Desk._name, API.RequestType.READ);
		this.read = 'GET_UNFILTERED';
		model.filter = {
			'day': this.state.filterDate,
		}
		this.data = await model.submit(null, this.read);
		this.data = this.data.items;
		this.setState({
			calendars: this.data
		});
		localStorage.setItem("dateHelpdesksUnfiltered", this.state.filterDate);
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	handleDateChange = async (name, date) => {
		this.state.filterDate = moment(date).format();
		this.handleToggleModal('showDate');
		await this.getHelpdesks();
	}

	toggleClose = () => {
		this.setState({calendarAlerts: null, toggleAlerts: false})
	}

	render() {
		const {loading} = this.state;

		const columns = [
			{
				Header: "Engineer",
				id: "engineer_name",
				accessor: obj => (obj.engineer_name)
			},
			{
				Header: "Time",
				id: "time",
				accessor: obj => (obj.time)
			},
			{
				Header: "Client Name",
				id: "name",
				accessor: obj => (obj.customer_name),
				Cell: props => {
					return (
						<span>
							<Link to={`/customers/${props.original.customer_pkey}`}>
								{props.original.customer_name}
							</Link>
						</span>
					);
				}
			},
			{
				Header: "FD Ticket #",
				id: "fresh_ticket",
				accessor: obj => freshdeskTicketExport(obj.fresh_ticket),
				Cell: props => {
					return (
						<span>
							<FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
						</span>
					);
				}
			},
			{
				Header: "Onsite",
				id: "on_site_time",
				accessor: obj => obj.on_site_time ? moment(obj.on_site_time).format('h:mm A') : ''
			},
			{
				Header: "Offsite",
				id: "off_site_time",
				accessor: obj => obj.off_site_time ? moment(obj.off_site_time).format('h:mm A') : ''
			},
			{
				Header: "Amount",
				id: "amount",
				accessor: obj => (obj.finance_amount),
				width: 100,
				className: "button-cell",
				Cell: props => {
					return (
						props.original.financial_pkey ?
							<Button
								color={'primary'}
								size={"sm"} block={true}
								onClick={() => {
									this.setState({
										financial: props.original.financial_pkey,
										ticket: props.original.Ticket,
									}, () => this.handleToggleModal('showFinancialModal'));
								}}
							>
								{props.original.finance_amount}
							</Button> : null
					);
				}
			},
			{
				Header: "Alerts",
				id: "alerts",
				width: 100,
				className: "button-cell",
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						props.original.alert_color ?
							<Button
								color={props.original.alert_color === 'red' ? 'danger' : 'caution'}
								size={"sm"} block={true}
								onClick={async () => {
									this.state.calendar = props.original.Pkey;
									this.handleToggleModal('help_desk_alerts_modal');
								}}
							>
								Show Alerts
							</Button> : null
					)
				}
			},
			{
				Header: "Review",
				id: "review",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 100,
				accessor: obj => obj.pkey,
				Cell: props => <TicketAuditReviewLink row={props.original}/>
			},
			{
				Header: "Reviewed By",
				id: 'userChecked',
				accessor: obj => (obj.userChecked)
			},
			{
				Header: "Ex. Amount",
				id: 'expected_labor',
				accessor: obj => (obj.expected_labor ?? 'N/A')
			},
			{
				Header: "% Off",
				id: 'percentage',
				accessor: obj => (obj.expected_labor && obj.finance_amount ? (Math.round(((parseFloat(obj.finance_amount) / parseFloat(obj.expected_labor) + Number.EPSILON) - 1) * 10000) / 100) + '%' : 'N/A')
			},
			{
				Header: "Ticket",
				id: "ticket_review",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 75,
				accessor: obj => obj.pkey,
				Cell: props => {
					return (
						<Button color="blue-hoki" size={"sm"} block={true} onClick={() => {
							this.setState({ticket: props.original.Ticket}, () => {
								this.handleToggleModal('showTicketModal');
							});
						}}>
							<Search fontSize={'small'}/>
						</Button>
					);
				}
			}
		];

		return (
			<div className={'box-body'}>
				<div className={"table-bar"}>

					<div className={"row rbc-toolbar"}>
						<div>
							<IconButton onClick={async () => {
								await this.setState({calendars: [], filterDate: moment(this.state.filterDate).subtract(1, 'day').format()})
								clearTimeout(this.timeout);
								this.timeout = setTimeout(async () => {
									await this.getHelpdesks();
								}, 750)
							}}><LeftArrowIcon/></IconButton>
							<button className="rbc-today" type="button" onClick={async () => {
								await this.setState({calendars: [], filterDate: moment(Date.now()).format()})
								clearTimeout(this.timeout);
								this.timeout = setTimeout(async () => {
									await this.getHelpdesks();
								}, 750)
							}}>Today
							</button>
							<IconButton onClick={async () => {
								await this.setState({calendars: [], filterDate: moment(this.state.filterDate).add(1, 'day').format()})
								clearTimeout(this.timeout);
								this.timeout = setTimeout(async () => {
									await this.getHelpdesks();
								}, 750)
							}}><RightArrowIcon/></IconButton>
						</div>
						<div className={"rbc-toolbar-label"}>
							<label onClick={() => {
								this.handleToggleModal('showDate')
							}}>
								{moment(this.state.filterDate).format('dddd MMM D')}
							</label>
						</div>
						<div style={{display: 'flex', justifyContent: 'flex-end', paddingTop: '8px'}}>
							<Button onClick={async () => {
								await this.getHelpdesks();
							}} size={"sm"} color="primary">
								<i className="fa fa-users"/>Refresh Data
							</Button>
						</div>
					</div>

				</div>

				<div className={'row'}>
					<div className={'col-12'}>
						{this.state.calendars?.length > 0 ? <ReactTable
								key={this.state.calendars}
								columns={columns}
								manual // Forces table not to paginate or sort automatically, so we can handle it server-side
								data={this.state.calendars ?? []}
								loadingText="Requesting Data"
								expanderDefaults={{
									sortable: false,
									resizable: true,
									filterable: false,
									width: undefined
								}}
								className="-striped -highlight"
								defaultPageSize={this.state.calendars?.length ?? 0}
								showPagination={false}
								getTdProps={() => {
									return {
										style: {
											height: '35px'
										}
									}
								}}
							/>
							: <div style={{alignContent: "center", fontSize: 25}}>
								No appointments scheduled for this day
							</div>}
					</div>
				</div>

				<Framework.Elements.UniversalModal
					size={"sm"}
					parent={this.state.calendar ?? null}
					title={"Help Desk Alerts"}
					object={Collections.HelpDeskAlerts}
					history={this.props.history}
					toggle={this.state.help_desk_alerts_modal}
					reportClose={() => this.handleToggleModal('help_desk_alerts_modal')}
					hideGoTo={true}
					hasSubmit={false}
				/>
				<Framework.Elements.UniversalModal
					size={"xl"}
					title={"Help Desk Contacted"}
					object={Collections.HelpDesksContacted}
					history={this.props.history}
					toggle={this.state.help_desk_contacted_modal}
					reportClose={() => this.handleToggleModal('help_desk_contacted_modal')}
					hideGoTo={true}
					hasSubmit={false}
					objectProps={{contacted_data: this.state.helpdesk_contacted_data, forHelpdesk: true}}
				/>
				<Framework.Elements.UniversalModal
					size={"xl"}
					id={this.state.ticket}
					history={this.props.history}
					object={Objects.ScheduleTicket}
					submitLabel={"Update Ticket"}
					deleteLabel={"Delete Ticket"}
					locations={[""]}
					title={"Review Ticket"}
					toggle={this.state.showTicketModal}
					reportClose={() => this.handleToggleModal('showTicketModal')}
					hasDelete={false}
					hasSubmit={false}
					hideGoTo={true}
				/>
				<Framework.Elements.UniversalModal
					size={"md"}
					parent={this.state.ticket}
					id={this.state.financial}
					history={this.props.history}
					object={Objects.Financial}
					title={"Review Financial"}
					toggle={this.state.showFinancialModal}
					reportClose={() => this.handleToggleModal('showFinancialModal')}
					hasDelete={false}
					hasSubmit={false}
					hideGoTo={true}
					objectProps={{hideBack: true}}
				/>
				<Modal
					isOpen={this.state.showDate}
					toggle={this.toggleClose}
					size={"sm"}
					backdrop={true}
					style={{display: "none"}}
				>
					<ModalBody>
						<Framework.Elements.Date
							label={"Custom Date"}
							value={this.state.filterDate}
							update={this.handleDateChange}
							open={this.state.showDate}
							clearable={false}
							cancelLabel={''}
						/>
					</ModalBody>
				</Modal>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
